// extracted by mini-css-extract-plugin
export default {"root":"fzlAQRHGuHhGJ6NzBrDI","icon":"xlibWx_a5zKUzarY0Xji","message":"TO_7gKDZ1iJv3uAPQnmQ xlibWx_a5zKUzarY0Xji"};